import { createClient } from "@supabase/supabase-js";

const supabaseAnonKey = process.env.VITE_SUPABASE_ANON_KEY;
const supabaseUrl = process.env.VITE_SUPABASE_URL;

//console.log("supabaseUrl", supabaseUrl);
//console.log("supabaseAnonKey", supabaseAnonKey);

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Supabase URL en anon key moeten worden ingesteld in de omgevingsvariabelen."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
